import store from '@/store';

export function sleep(ms) {
	return new Promise(resolve => setTimeout(resolve, ms));
}

export async function deepCopyObject(target, delay) {
	if(isNull(delay)) delay = 50;
	if(target !== undefined && target !== null) {
		await sleep(delay);
		return await JSON.parse(JSON.stringify(target));
	}else {
		return undefined;
	}
}

export function numberFormat(val, regex, replace) {
	if(regex === undefined) regex = /\B(?=(\d{3})+(?!\d))/g;
	if(replace === undefined) replace = ',';
	return String(val).replace(regex, replace);
}

export function isBlank(data) {
	return data === undefined || data === null || String(data).trim() === '';
}
export function isNotBlank(data) {
	return data !== undefined && data !== null && String(data).trim() !== '';
}

export function isNull(data) {
	return data === undefined || data === null;
}

export async function convertObjectToURIParam(searchParam) {
	let URIParam = '';

	if(searchParam !== undefined && searchParam !== null) {
		Object.keys(searchParam).forEach(paramNm => {
			if(paramNm === 'pageable') {
				let pageable = searchParam.pageable;

				Object.keys(pageable).forEach(key => {
					if(key === 'sort') {
						pageable.sort.forEach(sorter => {
							let direction = isBlank(sorter.direction) ? 'ASC' : sorter.direction.toUpperCase();
							URIParam += `&sort=${sorter.sortBy},${direction}`;
						})
					}else {
						URIParam += `&${key}=${pageable[key]}`;
					}
				})
			}else {
				URIParam += `&${paramNm}=${searchParam[paramNm]}`;
			}
		})
	}

	return URIParam.replace(/^&/, '?');
}

export function getCodeValueByLocale(codeObj) {
	if(codeObj === undefined || codeObj === null) return '';
	return store.getters['locale/LOCALE'] === 'en' ? codeObj.nmEng : codeObj.nmKor;
}

export function blobDownloader(fileName, data) {
	const blob = new Blob([data]);
	const fileObjectUrl = window.URL.createObjectURL(blob);

	// blob 객체 URL을 설정할 링크를 만듭니다.
	const link = document.createElement("a");
	link.href = fileObjectUrl;
	link.style.display = "none";
	link.download = fileName;

	document.body.appendChild(link);
	link.click();
	link.remove();

	// 다운로드가 끝난 리소스(객체 URL)를 해제합니다.
	window.URL.revokeObjectURL(fileObjectUrl);
}


export function createSortListAndClickCnt(sortList, baseSort){
	let sortByList = [];


	for(const sort in sortList){
		let sortBy = [
			{
				sortBy:sortList[sort],
				direction:'ASC',
			}
		]
		for(const base in baseSort){
			let baseSortItem = baseSort[base];
			sortBy.push(baseSortItem);
		}
		sortByList.push(sortBy);
	}
	sortByList.push(baseSort);
	let click = new Array(sortByList.length).fill(0);
	return {
		sortByList: sortByList,
		clickCnt : click
	};
}

export async function setSearchParamSortByCond(pageableSort, param, k){
	switch(param.clickCnt[k]) {
		case 0:
			let sort1 = await deepCopyObject(param.sortByList[k]);
			param.clickCnt.fill(0);
			param.clickCnt[k]++;
			return sort1;
		case 1:
			let sort2 = await deepCopyObject(param.sortByList[k]);
			sort2[0].direction = 'DESC';
			param.clickCnt[k]++;
			return sort2;
		case 2:
			let sort3 = await deepCopyObject(param.sortByList[param.sortByList.length - 1]);
			param.clickCnt.fill(0);
			return sort3;
		default:
			return null;
	}
}
export function disableCheck(authFlg){
	return authFlg !== '99';
}

export function rimsDisabledCheck(authFlg, authorConfirmYn){
	return (authFlg !== '99' || authorConfirmYn !== 'Y');
}

export function getEndDay(year, month) {
	if(month === '01' || month === '03' || month === '05' || month === '07' || month === '08' || month === '10' || month === '12') return '31';
	else if(month === '04' || month === '06' || month === '09' || month === '11') return '30';
	else {
		if(year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0)) return '29'
		else return '28'
	}
}